export default __webpack_public_path__ + "static/003-e525f699acd6b7df055743f22100481b.jpg";